const INTENT_KEY = 'palen.seo.opportunity.intent';
const INTENT_LIFETIME_MS = 24 * 60 * 60 * 1000;
const OPPORTUNITY_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function hasSeoOpportunityQuery(): boolean {
  return typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('seoOpportunity');
}

export function readSeoOpportunityId(): string | null {
  if (typeof window === 'undefined') return null;
  const value = new URLSearchParams(window.location.search).get('seoOpportunity');
  return value && OPPORTUNITY_ID_PATTERN.test(value) ? value.toLowerCase() : null;
}

export function rememberSeoOpportunityIntent(): void {
  const id = readSeoOpportunityId();
  if (!id) {
    if (hasSeoOpportunityQuery()) clearSeoOpportunityIntent();
    return;
  }
  try {
    window.sessionStorage.setItem(INTENT_KEY, JSON.stringify({ id, savedAt: Date.now() }));
  } catch {
    // The URL remains usable when browser storage is unavailable.
  }
}

export function readPendingSeoOpportunityId(): string | null {
  const currentId = readSeoOpportunityId();
  if (currentId) return currentId;
  if (hasSeoOpportunityQuery()) return null;
  try {
    const intent: unknown = JSON.parse(window.sessionStorage.getItem(INTENT_KEY) || 'null');
    if (!intent || typeof intent !== 'object') return null;
    const { id, savedAt } = intent as Record<string, unknown>;
    if (typeof id !== 'string' || !OPPORTUNITY_ID_PATTERN.test(id) || typeof savedAt !== 'number'
      || savedAt > Date.now() || Date.now() - savedAt > INTENT_LIFETIME_MS) {
      clearSeoOpportunityIntent();
      return null;
    }
    return id.toLowerCase();
  } catch {
    return null;
  }
}

export function clearSeoOpportunityIntent(): void {
  try {
    window.sessionStorage.removeItem(INTENT_KEY);
  } catch {
    // Leaving this page must remain possible without browser storage.
  }
}
